import { render } from "./issue_prescription_modal.vue?vue&type=template&id=b7a2544e&scoped=true"
import script from "./issue_prescription_modal.vue?vue&type=script&lang=js"
export * from "./issue_prescription_modal.vue?vue&type=script&lang=js"

import "./issue_prescription_modal.vue?vue&type=style&index=0&id=b7a2544e&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7a2544e"]])

export default __exports__